import { render, staticRenderFns } from "./addDialog.vue?vue&type=template&id=12bc8b50&scoped=true"
import script from "./addDialog.vue?vue&type=script&lang=js"
export * from "./addDialog.vue?vue&type=script&lang=js"
import style0 from "./addDialog.vue?vue&type=style&index=0&id=12bc8b50&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bc8b50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12bc8b50')) {
      api.createRecord('12bc8b50', component.options)
    } else {
      api.reload('12bc8b50', component.options)
    }
    module.hot.accept("./addDialog.vue?vue&type=template&id=12bc8b50&scoped=true", function () {
      api.rerender('12bc8b50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/components/physicalModel/addDialog.vue"
export default component.exports